/**
* Copyright Aquera Inc 2023
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import {css} from 'lit-element';

/**
 * Radio CSS
 */
export const styles = css`


  :host {
    display: block;
  }

  :host(:focus-visible) {
    outline: 0px;
  }

  .radio {
    display: inline-flex;
    align-items: top;
    font-size: 14px;
    font-weight: 500;
    color: var(--nile-colors-dark-900);
    vertical-align: middle;
    cursor: pointer;
    margin: 10px 0;
  }

  .radio--medium {
    --toggle-size: 14px;
    font-size: 14px;
  }

  .radio__checked-icon {
    display: inline-flex;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: var(--nile-colors-primary-600);
  }

  .radio__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--nile-type-scale-3);
    height: var(--nile-type-scale-3);
    border: solid 1px var(--nile-colors-neutral-700);
    border-radius: 50%;
    background-color: var(--nile-colors-white-base);
    color: transparent;
    transition: var(--nile-transition-duration-default) border-color, var(--nile-transition-duration-default) background-color,
    var(--nile-transition-duration-default) color, var(--nile-transition-duration-default) box-shadow;
  }

  .radio__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  /* Hover */
  .radio:not(.radio--checked):not(.radio--disabled) .radio__control:hover {
    border: 1px solid var(--nile-colors-primary-600);
    background: var(--nile-colors-primary-100);
  }

  /* Checked */
  .radio--checked .radio__control {
    color: var(--nile-colors-primary-600);
    border: 1px solid var(--nile-colors-primary-600);
    background-color: var(--nile-colors-white-base);
  }

  /* Checked + hover */
  .radio.radio--checked:not(.radio--disabled) .radio__control:hover {
    border: 1px solid var(--nile-colors-primary-900);
    background-color: var(--nile-colors-white-base);
  }

  /* Checked + hover */
  .radio__checked-icon:hover {
    background-color: var(--nile-colors-primary-900);
  }

  /* Checked + focus */
  :host(:focus-visible) .radio__control {
    outline: solid 3px hsl(198.6 88.7% 48.4% / 40%);
    outline-offset: 1px;
  }

  /* Disabled */
  .radio--disabled {
    opacity: 0.5;
    cursor: not-allowed;
    border-color: 1px solid var(--nile-colors-neutral-500);
  }

  /* When the control isn't checked, hide the circle for Windows High Contrast mode a11y */
  .radio:not(.radio--checked) svg circle {
    opacity: 0;
  }

  .radio__label {
    display: inline-block;
    color: var(--nile-colors-dark-900);
    line-height: var(--nile-type-scale-3);
    margin-inline-start: 0.5em;
    user-select: none;
    font-size: var(--nile-type-scale-3);
    margin-top: 2px;
  }
`;
